<div class="modal active" *ngIf="selectedProcedure">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Performance Analysis Options</h2>
      <div class="close" (click)="cancelPerformanceAnalysis()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="calculationName">Calculation Name</label>
                  <input name="calculationName" type="text"
                  forbiddenSubstring={{forbiddenSubstringName}} [(ngModel)]="performanceAnalysisDTOModal.calculationName"  alphaNumeric #calculationName="ngModel" required/>
                    <span class="error" *ngIf="calculationName.errors?.forbiddenName">
                      Name cannot contain {{forbiddenSubstringName}}.
                    </span>
                    <span class="error" *ngIf=" (calculationName.dirty || calculationName.touched) && calculationName.errors?.nonAlphaNumeric">
                      Only alphanumeric characters, hyphens and underscores are allowed.
                    </span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Processing Type</label>
                  <select [(ngModel)]="performanceAnalysisDTOModal.processingtype" name="processingtype"
                    id="processingtype" #processingtype='ngModel' (ngModelChange)="changeReceiverDelayStatus()" default>
                    <option value="0">Subtended Angle</option>
                    <option value="1">Redundancy</option>
                    <option value="2">Navigation System Error (NSE)</option>
                  </select>
                </div>
                <div>
                  <label for="">Result Analysis</label>
                  <select [(ngModel)]="performanceAnalysisDTOModal.resultanalysis" name="resultanalysis"
                    id="resultanalysis" #resultanalysis='ngModel'>
                    <option value="bar" selected>Bar Graphic</option>
                    <option value="plot">Plot Graphic</option>
                  </select>
                </div>
                <div style="justify-content: flex-start;">
                  <input class="mr-2" id="receiverDelay" name="receiverDelay" [(ngModel)]="performanceAnalysisDTOModal.receiverDelay" [disabled]="!performanceAnalysisDTOModal.isReceiverDelayEnable" type="checkbox"/>
                  <label for="">Consider receiver delay</label>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Procedure Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div style="justify-content: flex-start;">
                  <label for="">Aircraft Speed</label>
                    <input id="aircraftSpeed" name="aircraftSpeed" [(ngModel)]="selectedProcedure.aircraftspeed" type="number" style="width: 30%" required/><span>[kts]</span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title mb-2">
                <h4>Inertial Drift Calculation</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div style="justify-content: flex-start;">
                    <input class="mr-2" id="inertialCoasting" name="isInertial" [(ngModel)]="performanceAnalysisDTOModal.isInertial" type="checkbox" [disabled]="this.performanceAnalysisDTOModal.processingtype != '2'"/>
                    <label for="">Inertial Coasting</label>
                </div>
                <div style="justify-content: flex-start;">
                  <label for="">Max allowed NSE</label>
                    <input id="maxAllowedNSE" name="maxAllowedNSE" [(ngModel)]="performanceAnalysisDTOModal.maxAllowedNSE" type="number" style="width: 30%" [disabled]="!performanceAnalysisDTOModal.isInertial"/><span>[NM]</span>
                </div>
                <div style="justify-content: flex-start;">
                  <label for="">Inertial Drift Rate</label>
                    <input id="inertialRate" name="inertialDrift"  [(ngModel)]="performanceAnalysisDTOModal.inertialDrift" type="number" style="width: 30%" [disabled]="!performanceAnalysisDTOModal.isInertial"/><span>[NM/h]</span>
                </div>
                <div style="justify-content: flex-start;">
                  <label for="">Runway Update Error</label>
                    <input id="runwayUpdateError" name="runwayUpdateError" [(ngModel)]="performanceAnalysisDTOModal.runwayUpdateError" type="number" style="width: 30%" [disabled]="!performanceAnalysisDTOModal.isInertial"/><span>[NM]</span>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Inertial Drift Calculation</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div><label for="">Inertial Drift Rate</label><input [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.notupdate"
                  type="checkbox" id="infoupdate" name="infoupdate"/></div>
                  </div>
                </div>
                <div>
                  <label for="">Min Altitude</label>
                  <div class="coordenates">
                    <input id="minAltitudeFeet" name="minAltitudeFeet" #minAltitude='ngModel' [(ngModel)]="coverageDTOModal.minAltitude" type="number" style="width: 30%" [required]="!coverageDTOModal.isSingleLevel" [disabled]="coverageDTOModal.isSingleLevel"/><span>[ft]</span
                    ><input id="minAltitudeMeters" name="minAltitudeMeters" type="number" style="width: 30%" [required]="isSingleLevelDisabled" [disabled]="coverageDTOModal.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
                <div>
                  <label for="">Altitude Increment</label>
                  <div class="coordenates">
                    <input id="altitudeIncrementFeet" name="altitudeIncrementFeet" #altitudeIncrement='ngModel' [(ngModel)]="coverageDTOModal.altitudeInterval" type="number" style="width: 30%" [required]="!coverageDTOModal.isSingleLevel" [disabled]="coverageDTOModal.isSingleLevel"/><span>[ft]</span
                    ><input id="altitudeIncrementMeters" name="altitudeIncrementMeters" type="number" style="width: 30%" [required]="!coverageDTOModal.isSingleLevel" [disabled]="coverageDTOModal.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <div class="fields__btn">
            <button
              type="submit"
              [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
              (click)="performanceAnalysisCalculation(); ngForm.reset()"
              [disabled]="!ngForm.form.valid"
            >
              Ok
            </button>
            <a class="gray" href="#" type="reset" (click)="cancelPerformanceAnalysis()" value="Cancel">Cancel</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
